module.exports = __webpack_public_path__ + "img/play.d2778555.svg";